/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="95.58" height="54.59" viewBox="0 0 95.58 54.59" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <defs>
    <mask id="e983073f-7f01-4c05-85be-8dda11b2e1d2" x="40.99" y="41" width="13.6" height="13.6" maskUnits="userSpaceOnUse">
      <g transform="translate(-29.5 -49.5)">
        <polygon points="70.49 90.5 84.09 90.5 84.09 104.09 70.49 104.09 70.49 90.5" fill="#fff" fillRule="evenodd"/>
      </g>
    </mask>
  </defs>
  <g>
      <g mask="url(#e983073f-7f01-4c05-85be-8dda11b2e1d2)">
        <path d="M73.69,91.53a6.8,6.8,0,1,1-2.16,9.37,6.8,6.8,0,0,1,2.16-9.37" transform="translate(-29.5 -49.5)" fill="#ffb81c" fillRule="evenodd"/>
      </g>
    </g><polygon points="53.66 45.39 74.3 21.29 50.2 41.92 53.66 45.39" fill="#ffb81c" fillRule="evenodd"/><path d="M103.47,70.41,79.37,91a.51.51,0,0,0,0,.74l3.46,3.46a.49.49,0,0,0,.73,0l20.64-24.1A.5.5,0,0,0,103.47,70.41Zm-4.25,5L83.13,94.15l-2.7-2.7Z" transform="translate(-29.5 -49.5)" fill="#ffb81c"/><path d="M77.29,49.5a47.79,47.79,0,0,1,47.79,47.79A1.26,1.26,0,0,1,124,98.54H112.63a1.25,1.25,0,0,1-.13-2.49h10.07V95.8A45.29,45.29,0,0,0,78,52h-.75A45.3,45.3,0,0,0,32,95.8V96H42a1.24,1.24,0,0,1,1.24,1.12v.13a1.26,1.26,0,0,1-1.12,1.25H30.75a1.25,1.25,0,0,1-1.25-1.25A47.79,47.79,0,0,1,77.29,49.5Z" transform="translate(-29.5 -49.5)" fill="#0e497b"/><path d="M43.51,63.51a1.23,1.23,0,0,1,1.66-.09l.1.09,7.93,7.92a1.25,1.25,0,0,1-1.67,1.86l-.1-.09-7.92-7.92A1.25,1.25,0,0,1,43.51,63.51Z" transform="translate(-29.5 -49.5)" fill="#0e497b"/><path d="M77.29,49.5a1.26,1.26,0,0,1,1.25,1.12V62a1.25,1.25,0,0,1-2.49.13V50.75A1.25,1.25,0,0,1,77.29,49.5Z" transform="translate(-29.5 -49.5)" fill="#0e497b"/>
</svg>

    );
  }
}

Icon.displayName = 'DialGaugeIcon';

export default Icon;
